/* eslint-disable camelcase */
/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import Img from "gatsby-image";
import { graphql, Link } from "gatsby";
import { AppContext } from "~context/AppContext.jsx";
import { DocumentContext } from "~context/DocumentContext";
import Accordion from "~components/Accordion";
import Button from "~components/Button";
import Carousel from "~components/Carousel";
import Footer from "~components/Footer";
import GivePaireCTA from "~components/GivePaireCTA";
import Layout from "~components/Layout";
import LottieAnimation from "~components/LottieAnimation";
import ProductFeaturesPDP from "~components/ProductFeaturesPDP";
import ProductOverview from "~components/ProductOverview";
import SEO from "~components/SEO";
import SizeChart from "~components/SizeChart.jsx";
import SuggestedProducts from "~components/SuggestedProducts";
import ReviewsSection from "~components/ReviewsSection";
import Arrow from "~components/svg/Arrow";
import {
  pushProductEvent,
  fbqTrackProductGroup,
  gtagTrackProductView
} from "~utils/analytics";
import { useKeyPress } from "~utils/hooks";
import {
  getSelectableOptions,
  getVariantByOptions,
  getProductPreOrderMessage
} from "~utils/shopify";

import animationData from "~data/lottie/good-feels-wave.json";
import ProductPageBanner from "../components/ProductPageBanner";

const ProductPage = ({ data, location }) => {
  const {
    activeCurrency,
    addToCart,
    activeCurrencySymbol,
    inventoryCache,
    inventoryFetched
  } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  const [cartProduct, setCartProduct] = useState(null);
  const [chart, setChart] = useState(false);
  const [outOfStockVariants, setOutOfStockVariants] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const cms = data.sanityProduct;
  const reviews = data.allJudgemeReviews.edges[0].node;
  const options = getSelectableOptions(cms.shopifyProduct);
  const colourOptions = options?.Colour;
  console.log(cms.title);
  let i;
  // for (i=0;colourOptions?.[i];i++){
  //   if(colourOptions[i] == "Mixed Colours" || colourOptions[i] == "Neutral Shades" || colourOptions[i] == "Calm Colours" || colourOptions[i] == "Minimal Shades" || colourOptions[i] == "Multiple Colours"){
  //     colourOptions.splice(0,0,colourOptions[i]);
  //     colourOptions.splice(i+1,1);
  //   }
  // }
  const sizeOptions = options?.Size;
  const productName = cms.shopifyProduct?.handle?.split(`-`);
  let productPack = 1;
  for (i = 0; productName?.[i]; i++) {
    if (!isNaN(productName[i])) {
      productPack = productName[i];
      break;
    }
  }
  const packNum = parseInt(productPack);
  const isBrowser = () => typeof window !== `undefined`;
  let hrefHead;
  if (isBrowser()) {
    hrefHead = `${window?.location.href.split(`/products/`)[0]}/products/`;
  } else {
    hrefHead = `https://www.paire.com.au/products/`;
  }
  // console.log(hrefHead);
  let packOptions = null;
  switch (productName?.[0]) {
    case `everyday`:
      packOptions = [3, 6, 9];
      break;
    case `lounge`:
      packOptions = [4];
      break;
    case `casual`:
      packOptions = [4, 6, 12];
      break;
    case `sporty`:
      packOptions = [4, 6, 12];
      break;
    case `calf`:
      packOptions = [3, 6, 9];
      break;
    case `ankle`:
      packOptions = [3, 6, 9];
      break;
    case `quarter`:
      packOptions = [3, 6, 9];
      break;
    case `kids`:
      packOptions = [3, 6, 9];
      break;
    case `loose`:
      packOptions = [3, 6, 9];
      break;
    default:
      packOptions = [0];
  }

  if (cms.title?.search(`Sock Pack`) != -1) {
    packOptions = [6, 12];
  }

  if (cms.shopifyProduct?.handle.search(`free`) != -1) {
    packOptions = [0];
  }

  const selectOption = (key, value) => {
    setSelectedOptions({
      ...selectedOptions,
      [key]: value
    });
  };

  //

  /**
   * ---------------------------------------------------------------------------
   * useEffect []
   * Loads on page render and sets a default variant based on the first set
   * of available selectable Shopify options.
   */
  useEffect(() => {
    const defaultOptions = {};

    Object.keys(options).forEach(optionKey => {
      defaultOptions[optionKey] = options[optionKey]?.[0];
    });

    setSelectedOptions(defaultOptions);

    const variant = getVariantByOptions(cms.shopifyProduct, defaultOptions);

    gtagTrackProductView(cms.shopifyProduct, variant);
    fbqTrackProductGroup(
      `ViewContent`,
      cms.shopifyProduct,
      variant,
      activeCurrency
    );
  }, []);

  /**
   * ---------------------------------------------------------------------------
   * useEffect [selectedOptions]
   * Executes every time a user changes a selectable option. This will create
   * a cartProduct, which contains the cartProduct.variant object required for
   * checkout.
   */
  useEffect(() => {
    setCartProduct({
      ...cms.shopifyProduct,
      variant: getVariantByOptions(cms.shopifyProduct, selectedOptions),
      variants: null
    });
  }, [selectedOptions]);

  /**
   * ---------------------------------------------------------------------------
   * [useEffect] inventory
   * Executes on inventoryCache refresh, which usually fires once per site load.
   */

  useEffect(() => {
    if (!inventoryCache) {
      return;
    }

    const unstockedVariants = [];

    Object.keys(inventoryCache).forEach(variantId => {
      if (inventoryCache[variantId] <= 0) {
        unstockedVariants.push(variantId);
      }
    });

    setOutOfStockVariants(unstockedVariants);
  }, [inventoryCache]);

  /**
   * ---------------------------------------------------------------------------
   * [useEffect] cartProduct
   * Executes whenever the cartProduct is set. Useful for adding analytics
   * methods or additional hooks that fire on a user selecting a product.
   */
  useEffect(() => {
    if (!cartProduct) {
      return;
    }

    // TODO probably can be removed
    pushProductEvent(`productView`, cartProduct);
  }, [cartProduct]);

  //

  let colourOptionJSX = <></>;

  if (colourOptions?.[0]) {
    colourOptionJSX = (
      <article className="w-full relative block sm:mb-4">
        <h4 className="mt-v2 mb-v05 caption sm:mb-2">
          <span className="colour-label font-bold">Colour</span>
          {selectedOptions?.Colour ? `: ${selectedOptions.Colour}` : ``}
        </h4>

        <div className="w-full flex flex-wrap">
          {colourOptions.map(option => {
            let backgroundStyle = {};
            let hexes;
            let selected = false;

            data.allSanityColourMap.edges.forEach(({ node }) => {
              if (hexes) {
                return;
              }

              if (node.title.toLowerCase() === option.toLowerCase()) {
                ({ hexes } = node);
              }
            });

            if (cartProduct?.variant?.selectedOptions) {
              cartProduct.variant.selectedOptions.forEach(selectedOption => {
                if (selectedOption?.name && selectedOption.name === `Colour`) {
                  selected = selectedOption.value === option;
                }
              });
            }

            if (hexes?.[0]) {
              if (hexes.length === 3) {
                backgroundStyle = {
                  background: `linear-gradient(to right, ${hexes[0]} 33.333%, ${hexes[1]} 33.333%, ${hexes[1]} 66.667%, ${hexes[2]} 66.667%)`
                };
              } else if (hexes.length === 2) {
                backgroundStyle = {
                  background: `linear-gradient(to right, ${hexes[0]} 50%, ${hexes[1]} 50%)`
                };
              } else {
                backgroundStyle = {
                  backgroundColor: hexes[0]
                };
              }
            }

            return (
              <button
                key={option}
                type="button"
                className={`product-page__color-picker ${
                  selected ? `selected border-black` : ``
                } w-8 h-8 mr-2 mb-2 relative block rounded-full`}
                onClick={() => selectOption(`Colour`, option)}
              >
                <div
                  className="product-page__color-picker__bg w-full h-full relative rounded-full overflow-hidden pointer-events-none"
                  style={backgroundStyle}
                ></div>
              </button>
            );
          })}
        </div>
      </article>
    );
  }

  let sizeOptionJSX = <></>;

  let sizeText;

  if (cms.shopifyProduct?.handle.search(`kids`) != -1) {
    switch (selectedOptions?.Size) {
      case `S`:
        sizeText = `(AGE 3-5)`;
        break;

      case `M`:
        sizeText = `(AGE 6-8)`;
        break;

      case `L`:
        sizeText = `(AGE 9+)`;
        break;

      default:
        sizeText = ``;

        break;
    }
  } else {
    switch (selectedOptions?.Size) {
      case `S`:
        sizeText = `(US W4-7)`;
        break;

      case `M`:
        sizeText = `(US W8-11/M7-9)`;
        break;

      case `L`:
        sizeText = `(US M10-14)`;
        break;

      default:
        sizeText = ``;

        break;
    }
  }

  if (sizeOptions?.[0]) {
    sizeOptionJSX = (
      <article className="w-full relative block sm:mb-5">
        <div className="w-full flex items-center justify-between mt-v2 mb-v05 sm:mb-2">
          <h4 className="caption">
            <span className="font-bold">Size</span>
            {selectedOptions?.Size
              ? `: ${selectedOptions.Size} ${sizeText}`
              : ``}
          </h4>

          <h4 className="caption cursor-pointer">
            <button
              type="button"
              className="underline"
              onClick={() => setChart(true)}
            >
              Unisex Size Chart
            </button>
          </h4>
        </div>

        <div className="w-full relative">
          <div className="w-full relative items-center justify-between sm:gap-2">
            {sizeOptions.map(option => {
              let selected = false;

              if (cartProduct?.variant?.selectedOptions) {
                cartProduct.variant.selectedOptions.forEach(selectedOption => {
                  if (selectedOption?.name && selectedOption.name === `Size`) {
                    selected = selectedOption.value === option;
                  }
                });
              }

              let buttonText;

              switch (option.toLowerCase()) {
                case `s`:
                  buttonText = `SML`;
                  break;

                case `m`:
                  buttonText = `MED`;
                  break;

                case `l`:
                  buttonText = `LRG`;
                  break;

                case `xl`:
                default:
                  buttonText = `null`;

                  break;
              }

              if (buttonText == `null`) {
                return null;
              }

              return (
                <button
                  key={option}
                  className={`product-page__option ${
                    selected ? `bg-hit-pink` : `bg-off-white`
                  } border-black mr-3`}
                  type="button"
                  onClick={() => selectOption(`Size`, option)}
                >
                  <span className="f-button">{buttonText}</span>
                </button>
              );
            })}
          </div>
        </div>
      </article>
    );
  }

  //

  let packOptionJSX = <></>;

  if (productName?.[0]) {
    packOptionJSX = (
      <article className="w-full relative block sm:mb-5">
        <div className="w-full flex items-center justify-between mt-v2 mb-v05 sm:mb-2">
          <h4 className="caption">
            <span className="font-bold">Paire up and save</span>: {packNum} pack
          </h4>
        </div>

        <div className="w-full relative">
          <div className="w-full relative flex items-center sm:gap-2">
            {packOptions.map((option, index) => {
              let selected = false;
              selected = packNum === option;

              let href = null;
              if (isBrowser()) {
                href = `/products/${cms.shopifyProduct.handle}`;
              } else {
                href = `/products/`;
              }
              if (option === 1 && !selected) {
                href = `/products/${productName[0]}`;
                for (i = 1; productName[i]; i++) {
                  if (!isNaN(productName[i])) {
                    break;
                  }
                  href = `${href}-${productName[i]}`;
                }
              } else if (packNum === 1) {
                if (!selected) {
                  href = `${href}-${option}-pack`;
                }
              } else {
                href = `/products/${productName[0]}`;
                for (i = 1; productName[i]; i++) {
                  if (!isNaN(productName[i])) {
                    href = `${href}-${option}`;
                  } else {
                    href = `${href}-${productName[i]}`;
                  }
                }
              }

              return (
                <Link to={`${href}`} className="pack-link">
                  <button
                    key={option}
                    className={`product-page__option ${
                      selected ? `bg-hit-pink` : `bg-off-white`
                    } border-black wd100`}
                    type="button"
                  >
                    <span className="f-button">{option}</span>
                  </button>
                </Link>
              );
            })}
          </div>
        </div>
      </article>
    );
  }

  let freeDescriptionJSX = <></>;
  let freeitem = `false`;

  if (cms.shopifyProduct?.handle === `everyday-3-pack-free-paire`) {
    freeitem = `true`;
    freeDescriptionJSX = (
      <p className="w-full mt-v1 b2 sm:mb-5">
        <p className="b1 strong">
          "I love these socks, it's like wearing clouds on my feet. No more
          blisters, no more sweaty, smelly feet." - Emily
        </p>
        <ul className="ul-dot">
          <li>1 x ankle sock</li>
          <li>1 x quarter sock</li>
          <li>1 x calf sock</li>
          <li>1 x FREE mystery paire valued at $20</li>
        </ul>
        *One free mystery paire per customer only.
      </p>
    );
  }
  if (cms.shopifyProduct?.handle === `quarter-sock-3-pack-free-paire`) {
    freeitem = `true`;
    freeDescriptionJSX = (
      <p className="w-full mt-v1 b2 sm:mb-5">
        <p className="b1 strong">
          "Best socks I've ever worn in my (58 years) life. Extremely
          comfortable like walking on clouds all the time. Love them!" - Kate
        </p>
        <ul className="ul-dot">
          <li>3 x quarter socks</li>
          <li>1 x FREE mystery paire valued at $20</li>
        </ul>
        *One free mystery paire per customer only.
      </p>
    );
  }
  if (cms.shopifyProduct?.handle === `ankle-sock-3-pack-free-paire`) {
    freeitem = `true`;
    freeDescriptionJSX = (
      <p className="w-full mt-v1 b2 sm:mb-5">
        <p className="b1 strong">
          "Best socks I've ever worn in my (58 years) life. Extremely
          comfortable like walking on clouds all the time. Love them!" - Kate
        </p>
        <ul className="ul-dot">
          <li>3 x ankle socks</li>
          <li>1 x FREE mystery paire valued at $20</li>
        </ul>
        *One free mystery paire per customer only.
      </p>
    );
  }
  if (cms.shopifyProduct?.handle === `paire-x-3tt-gift-pack`) {
    freeitem = `true`;
    freeDescriptionJSX = (
      <p className="w-full mt-v1 b2 sm:mb-5">
        <p className="b1 strong">
          For all the Dad's in the world. Here's a pack for your special day:
        </p>
        <ul className="ul-dot">
          <li>1 x Snow Calf Socks</li>
          <li>1 x Fog Calf Socks</li>
          <li>1 x Bag of Coffee Beans (250 Gram)</li>
        </ul>
      </p>
    );
  }
  if (cms.shopifyProduct?.handle === `raya-collab-comfort-kit`) {
    freeitem = `true`;
    freeDescriptionJSX = (
      <p className="w-full mt-v1 b2 sm:mb-5">
        <p className="b1 strong">
          For your comfort, this limited pack includes:
        </p>
        <ul className="ul-dot">
          <li>Sky Ankle Socks</li>
          <li>Amber Quarter Socks</li>
          <li>
            ‘3 in 1’ Raya New York Style Cookie (choc peanut butter, matcha and
            choc chip walnut)
          </li>
          <li>Thyme Shortbread and Floral Yuzu Sandwich</li>
          <li>Teh Tarik (sweetened milk-based Ceylon tea)</li>
          <li>Spring Iced Tea (citrus butterfly tea)</li>
        </ul>
        <p className="b1 strong">
          All comfort kits will be dispatched via complimentary Express
          Delivery, every Wednesday and Friday.
        </p>
      </p>
    );
  }

  //

  let stocked = false;

  if (
    cartProduct?.variant?.id &&
    inventoryFetched &&
    !outOfStockVariants.includes(cartProduct.variant.id)
  ) {
    stocked = true;
  }

  //

  const close = () => {
    setChart(false);
  };

  const escKeyPressed = useKeyPress(`Escape`);
  const isBannerEnabled = data.sanityProductPageBanner?.enabled;
  useEffect(() => {
    close();
  }, [escKeyPressed]);

  const preOrderMessage = !stocked && getProductPreOrderMessage(cartProduct);
  // Check that variant is stock false
  // Check that product has timeline:* tag
  // Check that variant as available for sale true

  const preOrder =
    !stocked && preOrderMessage && cartProduct?.variant?.availableForSale;
  const available = stocked || preOrder;

  const buttonText = () => {
    if (stocked) return `Add to cart`;

    return preOrder ? `Pre Order` : `Sold out`;
  };

  return (
    <>
      <SEO
        customTitle={cms.title}
        customDescription={cms.tagline}
        customKeywords=""
        path={location.pathname}
      />
      <Layout className="product-page w-full relative bg-off-white">
        <SizeChart chart={chart} setChart={setChart} />

        {isBannerEnabled && <ProductPageBanner></ProductPageBanner>}

        <section className="grid">
          <article
            className={`${isBannerEnabled ||
              `pt-v4`} grid-end-8 flex flex-col `}
          >
            {device === `desktop` &&
              cms?.availableColours?.[0] &&
              cms.availableColours.map(colourBlock => {
                let key = ``;

                // console.log(cms.availableColours.length == 1);

                if (colourBlock?.colourRef?.title) {
                  key = `product-gallery-${colourBlock.colourRef.title}`;
                }

                if (cms.availableColours.length != 1) {
                  if (
                    !selectedOptions?.Colour ||
                    selectedOptions.Colour.toLowerCase() !==
                      colourBlock?.colourRef?.title?.toLowerCase()
                  ) {
                    return <React.Fragment key={key}></React.Fragment>;
                  }
                }

                return (
                  <ul
                    key={key}
                    className="animation-appear-right animation-delay-2"
                  >
                    {colourBlock?.gallery?.[0] &&
                      colourBlock.gallery.map(
                        (galleryItem, galleryItemIndex) => {
                          const imageKey = `${key}-${galleryItemIndex}`;

                          return (
                            <figure
                              key={imageKey}
                              className="animation-appear-down-slow w-full relative block mb-v2"
                              style={{
                                animationDelay: `${galleryItemIndex * 100 +
                                  100}ms`
                              }}
                            >
                              <Img
                                className="relative block rounded-lg"
                                fluid={galleryItem.asset.fluid}
                                alt={
                                  galleryItem?.altText
                                    ? galleryItem.altText
                                    : imageKey
                                }
                              />
                            </figure>
                          );
                        }
                      )}
                  </ul>
                );
              })}
          </article>

          {device !== `desktop` && cartProduct && (
            <article
              className={`${isBannerEnabled ||
                `pt-20`} grid-start-1 grid-end-12`}
            >
              {device !== `desktop` && (
                <Link
                  to="/products"
                  state={{ category: cms.productType }}
                  className="relative flex items-center self-start mb-v05 xs:mb-5"
                >
                  <Arrow className="product-page__sticky__arrow" />
                  <span className="caption">BACK TO SHOP</span>
                </Link>
              )}

              {cms?.availableColours?.[0] &&
                cms.availableColours.map(colourBlock => {
                  let key = ``;

                  if (colourBlock?.colourRef?.title) {
                    key = `product-gallery-${colourBlock.colourRef.title}`;
                  }

                  if (cms.availableColours.length != 1) {
                    if (
                      selectedOptions?.Colour?.toLowerCase() !==
                      colourBlock?.colourRef?.title?.toLowerCase()
                    ) {
                      return <div key={key} className="hidden"></div>;
                    }
                  }

                  return (
                    <div key={key}>
                      {colourBlock?.gallery?.[0] && (
                        <Carousel
                          keyPrefix="product-gallery"
                          items={colourBlock.gallery.map(
                            (galleryItem, galleryItemIndex) => {
                              const imageKey = `${key}-${galleryItemIndex}`;

                              return (
                                <figure
                                  key={imageKey}
                                  className="w-full relative block"
                                >
                                  <Img
                                    className="w-full relative block rounded-lg"
                                    fluid={galleryItem.asset.fluid}
                                    alt={
                                      galleryItem?.altText
                                        ? galleryItem.altText
                                        : imageKey
                                    }
                                  />
                                </figure>
                              );
                            }
                          )}
                          withBullets
                        />
                      )}
                    </div>
                  );
                })}
            </article>
          )}

          {cartProduct && (
            <div
              className={`${isBannerEnabled ||
                `pt-v5`} product-page__sticky animation-appear-left animation-delay-2 grid-end-4 sm:grid-end-12 sm:grid-start-1 h-screen sm:h-auto sticky sm:relative top-0 sm:top-auto left-0 sm:left-auto overflow-y-scroll sm:overflow-auto pb-v5`}
            >
              <article className="flex flex-col items-center pl-4 sm:pl-0">
                {device === `desktop` && (
                  <Link
                    to="/products"
                    state={{ category: cms.productType }}
                    className="relative flex items-center self-start mb-v05 xs:mb-5"
                  >
                    <Arrow className="product-page__sticky__arrow" />
                    <span className="caption">BACK TO SHOP</span>
                  </Link>
                )}

                {device !== `desktop` && (
                  <div className="w-full mb-3">{colourOptionJSX}</div>
                )}

                <div className="inline-block w-full mb-v1">
                  <h1 className="f4 font-bold mb-v1 float-left mr-3">
                    {cms.title}
                  </h1>

                  {cms?.packSize && (
                    <div className="relative flex items-center justify-center pt-2 pr-2 xs:pr-4 pb-1 xs:pb-1 pl-2 xs:pl-4 border-black border-2 overflow-hidden rounded-full bg-hit-pink inline-block fit-content paire-div">
                      <span
                        className={`block ${
                          device === `desktop` ? `caption` : `b2`
                        }`}
                      >
                        {cms.packSize}
                      </span>
                    </div>
                  )}
                </div>

                {cartProduct?.variant && (
                  <div className="w-full relative block items-center justify-start mb-v05 sm:mb-5">
                    <h3 className="f5 float-left">
                      {activeCurrencySymbol}{cartProduct.variant.price}
                    </h3>

                    {cartProduct.variant.compareAtPrice && (
                      <strike className="float-left">
                        <h3 className="f5 ml-3">
                          {activeCurrencySymbol}{cartProduct.variant.compareAtPrice}
                        </h3>
                      </strike>
                    )}
                  </div>
                )}

                {freeitem === `true` ? (
                  <>{freeDescriptionJSX}</>
                ) : (
                  <p className="w-full mt-v1 b2 sm:mb-5">
                    {cms.shopifyProduct.description ||
                      `Made from Paire’s supreme Cool Blend™ – Australian Merino wool
                  and sustainably sourced cotton, these socks are as good for
                  your toes as they are for your footprint.`}
                  </p>
                )}

                {packOptions[0] != 0 ? <>{packOptionJSX}</> : <></>}

                {device === `desktop` ? (
                  <>
                    {colourOptionJSX}
                    {sizeOptionJSX}
                  </>
                ) : (
                  <>{sizeOptionJSX}</>
                )}

                <div className="w-full relative mt-3 sm:mt-0 sm:mb-10">
                  <Button
                    className={`w-full ${
                      available ? `` : `pointer-events-none`
                    }`}
                    color={available ? `black` : `white`}
                    onClick={() => {
                      if (!available) {
                        return;
                      }

                      addToCart(cartProduct, 1);
                    }}
                  >
                    <span className="f-button">{buttonText()}</span>
                  </Button>
                </div>

                {preOrder && (
                  <div className="w-full relative sm:-mt-5 mt-3 sm:mb-10">
                    <p className="b2 text-tango italic">{preOrderMessage}</p>
                  </div>
                )}

                <Accordion />
              </article>
            </div>
          )}
        </section>

        <LottieAnimation
          id="feels-good-wave"
          animation={animationData}
          className="w-full relative block mt-v2"
          doLoad
          playing
        />

        <ProductFeaturesPDP />

        {cms.productOverviewBlocks.map((block, index) => {
          const key = `product-overview-${index}`;

          return (
            <div key={key}>
              <ProductOverview
                image={block.image.asset.fluid}
                imageAlt={block.image.altText}
                heading={block.heading}
                subheading={block.subHeading}
                text={block.text}
                position={block.position ? `right` : `left`}
                backgroundColor={block.backgroundColour}
              />
            </div>
          );
        })}

        <ReviewsSection data={reviews} />
        {/* <CustomerReview reviews={cms.reviews} /> */}

        <SuggestedProducts exclude={cms.id} productType={cms.productType} />

        <GivePaireCTA />
      </Layout>
      <Footer />
      <script
        dangerouslySetInnerHTML={{
          __html: ` 
    <script type="text/javascript">
        var _learnq = _learnq || [];

        var item = {
          Name: {cms.shopifyProduct.title},
          ProductID: {cms.shopifyProduct.id},
          Categories: {cms.shopifyProduct.productType},
          ImageURL: "https:{cms.shopifyProduct.images.originalSrc}",
          URL: "{process.env.GATSBY_STORE_URL}/products/{ cms.shopifyProduct.handle }",
          Brand: {cms.shopifyProduct.vendor},
          Price: {cms.shopifyProduct.variants.price},
          CompareAtPrice: {cms.shopifyProduct.variants.compareAtPrice}
        };

        _learnq.push(['track', 'Viewed Product', item]);
        _learnq.push(['trackViewedItem', {
          Title: item.Name,
          ItemId: item.ProductID,
          Categories: item.Categories,
          ImageUrl: item.ImageURL,
          Url: item.URL,
          Metadata: {
            Brand: item.Brand,
            Price: item.Price,
            CompareAtPrice: item.CompareAtPrice
          }
        }]);
      </script> `
        }}
      />
      `
    </>
  );
};

ProductPage.propTypes = {
  location: PropTypes.shape({}).isRequired
};

export default ProductPage;

export const query = graphql`
  query ProductPage($id: String!) {
    sanityProduct(id: { eq: $id }) {
      id
      title
      packSize
      productType

      reviews {
        customer
        text
      }

      shopifyProduct {
        id
        handle
        title
        description
        images {
          originalSrc
        }
        productType
        vendor
        variants {
          id
          sku
          title
          image {
            originalSrc
          }
          price
          compareAtPrice
          availableForSale
          selectedOptions {
            name
            value
          }
        }
        tags
      }

      availableColours {
        colourRef {
          hexes
          title
        }

        gallery {
          asset {
            fluid(maxWidth: 1440) {
              ...GatsbySanityImageFluid
            }
          }
          altText
        }
      }

      productOverviewBlocks {
        subHeading
        heading
        text
        position
        backgroundColour
        image {
          asset {
            fluid(maxWidth: 768) {
              ...GatsbySanityImageFluid
            }
          }
          altText
        }
      }
    }

    allSanityProduct {
      edges {
        node {
          title
          tagline
          description
          image {
            asset {
              fluid(maxWidth: 768) {
                ...GatsbySanityImageFluid
              }
            }
          }
        }
      }
    }

    allShopifyProduct {
      edges {
        node {
          id
          title
          description
          handle
          images {
            originalSrc
          }
          variants {
            id
            sku
            title
            image {
              originalSrc
            }
            price
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }

    allStampedReviews {
      edges {
        node {
          data {
            author
            reviewTitle
            reviewMessage
            reviewRating
            reviewDate
          }
          totalAll
          ratingAll
        }
      }
    }

    allJudgemeReviews {
      edges {
        node {
          reviews {
            reviewer {
              name
            }
            title
            body
            rating
            created_at
          }
        }
      }
    }

    allShopifyAdminProduct {
      edges {
        node {
          products {
            alternative_id
            handle
            variants {
              alternative_id
              sku
              inventory_item_id
              title
            }
          }
        }
      }
    }

    allSanityColourMap {
      edges {
        node {
          hexes
          title
        }
      }
    }

    sanityProductPageBanner {
      content
      enabled
    }
  }
`;
